import { ReactElement } from 'react';
import { JobDatasetsContainer } from '../../../../modules/jobs/containers/details/JobDatasets.container';

export const InferenceDetailsDatasetsView = (): ReactElement => <JobDatasetsContainer />;
